import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import classes from "./style.module.css";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";

import PrizePlaceHolder from "../../assets/images/pointsShop/pointsPlaceHolder.png";
import RCoin from "../../assets/images/icons/RCoin.png";

import { useNavigate, useParams } from "react-router-dom";
import errorHandler from "../../assets/utils/ErrorHandler";
import appApi from "../../assets/utils/AppApi";
import Loading from "../../assets/containers/loadingDialog";
import { baseURL } from "../../assets/constants/baseUrl";
import UsersRequests from "../../assets/services/user";
import PurchaseDialog from "./PurchaseDialog";
import { convertToShamsi } from "../../assets/utils/ConvertToShamsi";
import Hint from "../../assets/components/Hint";

const getCancelationMessages = (cancellSetting) => {
  if (!cancellSetting?.enabled) {
    return ["این آیتم قابلیت لغو ندارد. درانتخاب خود دقت لازم را داشته باشید."];
  }
  const messages = [];
  if (cancellSetting.limitToDate && cancellSetting.limitToDateDate) {
    const formattedDate = convertToShamsi(cancellSetting.limitToDateDate);
    messages.push(
      `در صورت انصراف از خرید، تا تاریخ ${formattedDate} می‌توانید خرید خود را لغو نمایید`
    );
  }
  if (cancellSetting.limitToDay && cancellSetting.limitToDayDay) {
    messages.push(
      `در صورت انصراف از خرید، از زمان انتخاب تا ${cancellSetting.limitToDayDay} روز می‌توانید خرید خود را لغو نمایید`
    );
  }
  if (cancellSetting.penallty && cancellSetting.penallty > 0) {
    messages.push(
      `در صورت انصراف از خرید در مهلت تعیین شده، ${cancellSetting.penallty} درصد از سکه‌های پرداخت شده به عنوان جریمه کسر خواهد شد.`
    );
  }
  if (messages.length === 0) {
    messages.push("این آیتم قابلیت لغو دارد");
  }
  return messages;
};

const getExpireMessages = (expireSetting) => {
  if (!expireSetting?.enabled) {
    return [];
  }
  const messages = [];
  if (expireSetting.limitToDate && expireSetting.limitToDateDate) {
    const formattedDate = convertToShamsi(expireSetting.limitToDateDate);
    messages.push(`مهلت دریافت این جایزه تا تاریخ ${formattedDate} می‌باشد`);
  }
  if (expireSetting.limitToDay && expireSetting.limitToDayDay) {
    messages.push(
      `مهلت دریافت این جایزه تا ${expireSetting.limitToDayDay} روز پس از انتخاب می باشد`
    );
  }
  if (expireSetting.penallty && expireSetting.penallty > 0) {
    messages.push(
      `در صورت عدم دریافت هدیه در مهلت تعیین شده، ${expireSetting.penallty} درصد از سکه‌های پرداخت شده به عنوان جریمه کسر خواهد شد`
    );
  }
  return messages;
};

const PointsShopDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [item, setItem] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingPurchase, setLoadingPurchase] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const dispatch = useDispatch();

  const getItem = async () => {
    setLoading(true);
    try {
      await appApi.get(`/pointshop/item/getsingle/${id}`).then(({ data }) => {
        setItem(data);
        setLoading(false);
      });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const handlePurchase = async () => {
    if (!loadingPurchase) {
      setLoadingPurchase(true);
      try {
        await appApi.get(`/pointshop/purchase/${id}`).then(({ data }) => {
          setLoadingPurchase(false);
          dispatch(UsersRequests.getme());
          dispatch(UsersRequests.getUserPoint());
          navigate(`/awardReceipt/${data.purchaseInfo._id}?showMessage=true`);
        });
      } catch (error) {
        errorHandler(error);
        setLoadingPurchase(false);
      }
    }
  };

  useEffect(() => {
    getItem();
    return () => {
      setItem();
    };
  }, []);

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        {loading && (
          <Loading
            className={"w-100 d-flex justify-content-center my-5 py-5"}
          />
        )}
        {item && (
          <div className={classes.cardDetails}>
            <img
              src={
                item.cover
                  ? `${baseURL}file/get/${item.cover}`
                  : PrizePlaceHolder
              }
              alt="prize picture"
              className={classes.prizeImage}
            />
            <p className={classes.detailsTitle}>{item.name}</p>
            <p
              className={classes.details}
              dangerouslySetInnerHTML={{ __html: item.description }}
            ></p>
            <div className={classes.prizeDetailsCoin}>
              <p>قیمت:</p>
              <span>{item.price}</span>
              <img src={RCoin} alt="coin" />
            </div>
            <div className="my-3">
              {getCancelationMessages(item.cancellSetting).map((msg, index) => (
                <Hint key={index} hintText={msg} />
              ))}
              {getExpireMessages(item.expireSetting).map((msg, index) => (
                <Hint key={index} hintText={msg} />
              ))}
            </div>
            <div className={classes.inventoryContainer}>
              <span>موجودی ویترین:</span>
              <span>{item.inventory} عدد</span>
            </div>
            <button
              className={classes.buyButton}
              onClick={() => setOpenConfirm(true)}
            >
              {loadingPurchase ? "صبر کنید..." : "خرید"}
            </button>
          </div>
        )}
      </div>
      <PurchaseDialog
        open={openConfirm}
        close={() => setOpenConfirm(false)}
        itemName={item?.name}
        itemPrice={item?.price}
        handleConirm={handlePurchase}
      />
    </AnimatedPageContainer>
  );
};

export default PointsShopDetails;
